import { X } from "lucide-react";

interface IProps {
  onClose: () => void;
}

export const IntegrationIncompleteSection = ({ onClose }: IProps) => {
  return (
    <div className="flex flex-col gap-5 w-full h-full px-5 pt-5 pb-5">
      <X
        size={13}
        className="cursor-pointer self-end text-muted-foreground hover:text-foreground transition-colors duration-150"
        style={{ width: '13px', height: '13px', minWidth: '13px', minHeight: '13px' }}
        onClick={onClose}
      />

      <div className="flex flex-col w-full h-full gap-5 justify-center items-center">
        <p className="text-center w-full text-[13px] text-muted-foreground">
          Finish setting up this connection in the configuration page.
        </p>
      </div>
    </div>
  );
};
